/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The schema for updating a draft.
 */
export interface DraftUpdate {
    /** Metadata about the draft. */
    meta?: Truvity.DraftMeta;
    /** The values of the draft. */
    values?: Truvity.CredentialClaimValues;
}
